import { render, staticRenderFns } from "./BusAssetStorageDetailList.vue?vue&type=template&id=399f4904&scoped=true&"
import script from "./BusAssetStorageDetailList.vue?vue&type=script&lang=js&"
export * from "./BusAssetStorageDetailList.vue?vue&type=script&lang=js&"
import style0 from "./BusAssetStorageDetailList.vue?vue&type=style&index=0&id=399f4904&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399f4904",
  null
  
)

export default component.exports